import React from 'react';
import {trans} from './utils';
import Advert from './Advert';

var ADDRESS = {
  en: 'Address',
  hr: 'Adresa',
}

var PHONE = {
  en: 'Phone',
  hr: 'Telefon',
}

var WORKING_HOURS = {
  en: 'Working hours',
  hr: 'Radno vrijeme',
}

var DAYS = ['%sun', '%mon', '%tue', '%wed', '%thu', '%fri', '%sat'];

var DAYS_SHORT = {
  hr: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
  en: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
  de: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
  fr: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
  it: 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
  cs: 'ne_po_út_st_čt_pá_so'.split('_'),
}


class PoiInfo extends React.Component {
  render() {
    let {poi, lang} = this.props;

    return (
      <div className="PoiInfo">
        <h3>{trans(lang, poi.name)}</h3>
        <table>
          <tbody>
            <tr>
              <td>{ trans(lang, ADDRESS) }</td>
              <td>{ poi.address }</td>
             </tr>
            { poi.phone === '' ? null :
              <tr>
                <td>{ trans(lang, PHONE) }</td>
                <td>{ poi.phone }</td>
               </tr>
            }
            { poi.web_address === '' ? null :
              <tr>
                <td>Web</td>
                <td className="web">{ this.getWebAddress() }</td>
               </tr>
            }
            { poi.working_hours === '' ? null :
              <tr>
                <td>{ trans(lang, WORKING_HOURS) }</td>
                <td>{ this.getWorkingHours() }</td>
               </tr>
            }
          </tbody>
        </table>
        { this.getWalkingDuration() }
        { this.getDrivingDuration() }
      </div>
    )
  }

  getWalkingDuration() {
    let poi = this.props.poi;

    if (poi.directions == null || poi.directions.walking_duration == null) {
      return null;
    }
    let min = Math.ceil(poi.directions.walking_duration / 60) + ' min';
    return (
      <div className="walkingDuration">
        <img src={require('./img/walking_icon.svg')} alt="" />
        { min }
      </div>
    )
  }

  getDrivingDuration() {
    let poi = this.props.poi;

    if (poi.directions == null || poi.directions.driving_duration == null) {
      return null;
    }

    if (poi.directions.walking_duration && poi.directions.walking_duration / 60 < 15) {
      return null;
    }

    let min = Math.ceil(poi.directions.driving_duration / 60) + ' min';

    return (
      <div className="drivingDuration">
        <img src={require('./img/car_icon.svg')} alt="" />
        { min }
      </div>
    )
  }

  getWorkingHours() {
    let hours = this.props.poi.working_hours;
    hours = hours.replace(/%[a-z]{3,3}/g, s => {
      let index = DAYS.indexOf(s);
      if (index === -1) return '';
      return DAYS_SHORT[this.props.lang][index];
    });
    return hours.split('//').map(s => <div>{ s }</div>);
  }

  getWebAddress() {
    let web = this.props.poi.web_address;
    if (web == null) return '';
    if (web.startsWith('http://')) {
      web = web.substr(7);
    }
    if (web.startsWith('https://')) {
      web = web.substr(8);
    }
    if (web.endsWith('/')) {
      web = web.substr(0, web.length-1);
    }
    return web;
  }
}

export default class Header extends React.Component {

  render () {
    let {lang, category, sponsor, poi} = this.props;

    if (sponsor && sponsor.header) {
      sponsor = <Advert advert={sponsor.header} loop={true} />;
    } else {
      sponsor = null;
    }

    return (
      <header>
        <h2>{trans(lang, category.name)}</h2>
        { sponsor }
        { poi == null ? null : <PoiInfo poi={poi} lang={lang} /> }
      </header>
    );
  }
}

